<script setup>
import IconChipExtraction from '@/Components/Icons/IconChipExtraction.vue';
</script>

<template>
  <div
    v-tooltip="'Redirect Present'"
    class="text-grey-500 flex items-center gap-1 text-xs"
  >
    <IconChipExtraction :size="16" />
    {{ $t('domain_analysis.partials.redirect_present.redirect') }}
  </div>
</template>
